/* eslint-disable jsx-a11y/img-redundant-alt */
import React from "react";
import avatar1 from '../../../../assets/img/avatars/avatarSimmmple.png';



const TestimonialSlider = () => {
  return (
  <section className="bg-white dark:bg-gray-900 r">
  <div className="container mx-auto px-4 rounded-lg">
      <figure className="w-full max-w-8xl">
          <svg className="h-12 ml-5 mx-auto mb-3 text-gray-400 dark:text-gray-600" viewBox="0 0 24 27" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M14.017 18L14.017 10.609C14.017 4.905 17.748 1.039 23 0L23.995 2.151C21.563 3.068 20 5.789 20 8H24V18H14.017ZM0 18V10.609C0 4.905 3.748 1.038 9 0L9.996 2.151C7.563 3.068 6 5.789 6 8H9.983L9.983 18L0 18Z" fill="currentColor"/>
          </svg> 
          <blockquote className=" bg-gray-100 p-6 border-l-4 border-blue-500 text-lg  my-8">
              <p >"Edgar was an absolute game-changer for my son's precalculus class. He went from struggling with the material and receiving a C on his first test to earning a solid A by the end of the quarter. Edgar has an extensive understanding of precalculus concepts and was able to explain complex topics like algebraic manipulations and also SAT prep problems in a way that just clicked for my son. The tutor's patience and ability to identify exactly what he was doing incorrectly made all the difference. They also provided excellent test-taking strategies and genuinely cared about my son's success. I highly recommend Edgar to anyone needing help with Precalculus and SAT."</p>
          </blockquote>
          <figcaption className="flex items-center justify-center mt-6 space-x-1">
              <img className="w-10 h-10 rounded-full" src={avatar1} alt="profile picture"/>
              <div className="flex items-center divide-x-2 divide-gray-500 dark:divide-gray-700">
                  <div className="pr-3 font-medium text-blue-800 dark:text-white">Ranjini W</div>
                  <div className="pl-3 text-sm font-light text-gray-500 dark:text-gray-400">Parent</div>
              </div>
          </figcaption>
      </figure>
  </div>
</section>
  );
};

export default TestimonialSlider;
